import { render, staticRenderFns } from "./leaderboardPage.vue?vue&type=template&id=dc0a4c94&scoped=true&"
import script from "./leaderboardPage.vue?vue&type=script&lang=js&"
export * from "./leaderboardPage.vue?vue&type=script&lang=js&"
import style0 from "./leaderboardPage.vue?vue&type=style&index=0&id=dc0a4c94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0a4c94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VProgressLinear,VRow,VSelect})
